/**
 * Format a numeric price as a French Euro string.
 * Example: 129 → "129,00 €", 1234.5 → "1 234,50 €"
 */
export function formatPrice(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "0,00 €";
  return n.toLocaleString("fr-FR", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
